import {serviceResourceCenterRouter} from "@/router/branches/service-resource-center";
import {serviceRouter} from "@/router/branches/service";
import {aboutRouter} from "@/router/branches/about";

export default {
    serviceResourceCenterRouter,
    serviceRouter,
    aboutRouter
}